import { Conversion } from "@/components/Price/components/conversion";
import { Main } from "@/components/Price/components/main";
import { StrikeThrough } from "@/components/Price/components/strikeThrough";
import { Base } from "@/components/Price/price.base";

export const Price = Object.assign(Base, {
    Main: Main,
    StrikeThrough: StrikeThrough,
    Conversion: Conversion
});
